import React from "react";
import PackagesPage from "../PackagesPage";
import Image from "../../../assets/img/Ofuro_Off_Grid_package.jpg";
import Image2 from "../../../assets/img/Ofuro_Premium_package.jpg";
import { ReactComponent as PeopleIconComponent } from "../../../assets/img/people-icon.svg";
import { ReactComponent as CheckIconComponent } from "../../../assets/img/check-icon.svg";
import modelNodes from "./modelNodes";

const title = "Ofuro Hot Tub";

const breadcrumbData = [
    {
        title,
        active: true,
    },
    {
        title: "Packages",
        active: false,
    },
];

const checkBoxesData = [
    {
        label: "Ofuro Premium Package",
        url: "model/1",
        image: Image2,
        price: 3150,
        oldPrice: 4000,
        id: 2,
        modelId: "7a071c3d768846e39894e5d72dcf99f0",
        listProps: [
            {
                icon: (
                    <React.Fragment>
                        <PeopleIconComponent />
                    </React.Fragment>
                ),
                text: "Fits 1-2 people",
            },
            {
                icon: (
                    <React.Fragment>
                        <CheckIconComponent />
                    </React.Fragment>
                ),
                text: "Special offer combo",
            },
            {
                text: "Chimney heat guard",
            },
            {
                text: "LED multicolour lighting",
            }
        ],
    },
    {
        label: "Ofuro Off-Grid Package",
        url: "model/2",
        image: Image,
        price: 2950,
        oldPrice: 3700,
        id: 3,
        modelId: "9d29f1906deb4cea89539cc1b7229135",
        listProps: [
            {
                icon: (
                    <React.Fragment>
                        <PeopleIconComponent />
                    </React.Fragment>
                ),
                text: "Fits 1-2 people",
            },
            {
                icon: (
                    <React.Fragment>
                        <CheckIconComponent />
                    </React.Fragment>
                ),
                text: "Special offer combo",
            },
        ],
    },
];

const keyFeaturesData = {
    id: 1,
    label: "Design Your Hot Tub",
    price: 2999,
    url: "custom",
    modelId: "f1564f68788f4e7fb3de2c16aa1f0b7d",
    modelNodes,
    listProps: [
        {
            text: "Ready to ship in 1-4 weeks",
        },
    ],
};

const limitedOfferIntroData = {
    title: "Ofuro <em>Specials</em>",
    text: "We carry stocks of our most popular Deluxe wood fired hot tubs, so they're ready to ship as soon as you order. Check out our range of pre-configured models.",
    discount: 22,
};

const headlineData = {
    title: "Ofuro Premium Package",
    discount: 22,
};

const Home = () => (
    <PackagesPage
        title={title}
        headlineData={headlineData}
        limitedOfferIntroData={limitedOfferIntroData}
        keyFeaturesData={keyFeaturesData}
        checkBoxesData={checkBoxesData}
        breadcrumbData={breadcrumbData}
    />
);

export default Home;
